var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4.54741V16.1382C20 16.8916 19.39 17.5016 18.6367 17.5016H15.4542V9.77491L10 13.8666L4.54583 9.77491V17.5024H1.36333C1.18423 17.5024 1.00688 17.4671 0.841416 17.3986C0.675954 17.33 0.525625 17.2295 0.399017 17.1028C0.272408 16.9761 0.172003 16.8257 0.103539 16.6602C0.0350736 16.4947 -0.000109223 16.3173 2.5471e-07 16.1382V4.54741C2.5471e-07 2.86158 1.92417 1.89908 3.2725 2.91075L4.54583 3.86658L10 7.95658L15.4542 3.86491L16.7275 2.91075C18.075 1.89991 20 2.86158 20 4.54741Z",
    fill: "#D6C79D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.1c3f49eed2970dd7a19ccc7f48fc4e61.svg";
export { ForwardRef as ReactComponent };